import * as React from "react";
import { TooltipApi } from "sb-resp-ui";

export class EventCardIcon extends React.PureComponent<{
    className?: string,
    onClick?: React.MouseEventHandler,
    tooltip?: string
}, {}> {
    tooltip: {
        "data-tooltip-message": string;
    };

    constructor(props) {
        super(props);
        this.tooltip = TooltipApi.getInstance().setMessage(this.props.tooltip);
    }

    render() {
        const addClassName = this.props.className ? this.props.className : "";

        return (
            <div className={`rj-ev-list__ev-card-icon ${addClassName}`} onClick={this.props.onClick} {...this.tooltip} data-uat="div-ev-list-ev-card-icon" >
                {this.props.children}
            </div>
        )
    }
}